import AppRouter from "routers/AppRouter";
import { ToastProvider } from "components/toast/ToastProvider";

export default function App() {
  return (
    <ToastProvider>
      <AppRouter />
    </ToastProvider>
  );
}